export const SEARCH_FORM = "search_referral_form";

export const PAGE_COUNT = 200;
